import {Controller} from "@hotwired/stimulus"
import {get} from "@rails/request.js";
import flatpickr from "flatpickr"

// Connects to data-controller="organization-event"

export default class extends Controller {
  static targets = ["dateField", "clearDateBtn", "dateFilterContainer"];

  static values = {
    url: String,
  }

  connect() {
    // The date filter is omitted from the DOM when the org has no events, so
    // only wire up flatpickr when its input is actually present.
    if (this.hasDateFieldTarget) {
      flatpickr(this.dateFieldTarget, {
        onChange: this.handleDateChange.bind(this),
      });
    }
  }

  openDatePicker() {
    this.dateFieldTarget.click()
  }

  handleDateChange(selectedDates, dateStr) {
    this.applyFilter()
    if (this.dateFieldTarget.value != "") {
      this.clearDateBtnTarget.classList.remove("d-none")
      this.dateFilterContainerTarget.classList.remove("mt-24px")
    } else {
      this.clearDateBtnTarget.classList.add("d-none")
      this.dateFilterContainerTarget.classList.add("mt-24px")
    }
  }

  searchEvent(event) {
    this.applyFilter()
  }

  applyFilter() {
    let filtersApplied = false
    const url = new URL(this.urlValue);
    if (this.dateFieldTarget.value != "") {
      filtersApplied = true
    }

    url.searchParams.set("date", this.dateFieldTarget.value)
    url.searchParams.set("filters", filtersApplied)

    get(url.href, {
      responseKind: "turbo-stream",
    });
  }

  clearDateFilter() {
    this.dateFieldTarget._flatpickr.clear();
  }
}
